import React, { useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import { MODE_OF_TRANSPORTATION, travelTime } from '../../../constants'
import PaneHeader from '../panes/PaneHeader'
import CustomDropdown from '../../common/CustomDropdown'

const BulkIsochronePane = ({ bulkIsochrone, group, uiStore, dataStore, selectionStore, t }) => {
  useEffect(() => {
    const map = uiStore && uiStore.map && uiStore.map.leafletElement
    const center = map && typeof map.getCenter === 'function' ? map.getCenter() : null
    const zoom = map && typeof map.getZoom === 'function' ? map.getZoom() : null
    if (uiStore && typeof uiStore.suppressMapBoundsTemporarily === 'function') {
      uiStore.suppressMapBoundsTemporarily(500)
    }
    const timer = setTimeout(() => {
      if (map && center && zoom != null) {
        map.setView(center, zoom, { animate: false })
      }
    }, 0)
    return () => clearTimeout(timer)
  }, [])

  const handleSubmit = async () => {
    uiStore.setProcessing(true)

    const currentYear = dataStore.defaultYear.result
    const currentDataset = dataStore.defaultDsName

    const result = await bulkIsochrone.add(
      group.pk || group.id,
      currentYear,
      currentDataset
    )
    if (result) {
      await group.loadGeometries()
      selectionStore.clear()
      uiStore.setProcessing(false)
    } else {
      uiStore.setProcessing(false)
    }
  }

  const handleCancel = () => {
    selectionStore.clear()
  }

  return (
    <div className='line-pane bulk-isochrone-pane'>
      <PaneHeader
        icon={travelTime}
        title={t('ITEM.BULK_TRAVEL_TIME_TITLE', { defaultValue: 'Batch Isochrones' })}
        onClose={handleCancel}
      />

      <p className='text-regular bulk-pane-description' style={{ marginBottom: '14px', fontSize: '13px', color: '#64748B' }}>
        {t('ITEM.BULK_TRAVEL_TIME_DESC')}
      </p>

      <form onSubmit={(e) => { e.preventDefault(); handleSubmit() }}>
        <section className='spaced-children bulk-pane-form-section'>
          <label>
            <span>{t('GLOBAL.MODE_OF_TRANSPORTATION', { defaultValue: 'Mode of transport' })}</span>
            <CustomDropdown
              value={bulkIsochrone.modeOfTransportation}
              onChange={(val) => {
                bulkIsochrone.modeOfTransportation = val
              }}
              options={MODE_OF_TRANSPORTATION}
            />
          </label>
          <label>
            <span>{t('GLOBAL.TRAVEL_TIME', { defaultValue: 'Travel time' })}</span>
            <div className='input-with-unit'>
              <input
                type='number'
                value={bulkIsochrone.travelTime}
                onChange={(e) => { bulkIsochrone.travelTime = e.target.value }}
              />
              <span className='input-with-unit__unit'>
                {t('GLOBAL.MINUTES', { defaultValue: 'minutes' })}
              </span>
            </div>
            {bulkIsochrone.invalid.has('travelTime') && (
              <span className='invalid'>
                {bulkIsochrone.invalid.get('travelTime')}
              </span>
            )}
          </label>
        </section>
        <section>
          <div className='centered-button-row'>
            <button type='button' onClick={handleCancel}>
              <span>{t('GLOBAL.CANCEL', { defaultValue: 'Cancel' })}</span>
            </button>
            <button type='submit' className='full-btn'>
              <span>{t('GLOBAL.CONFIRM_ADD', { defaultValue: 'Create isochrones' })}</span>
            </button>
          </div>
        </section>
      </form>
    </div>
  )
}

export default withTranslation()(inject('uiStore', 'dataStore', 'selectionStore')(observer(BulkIsochronePane)))
